<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-12 15:50:37
 * @FilePath: \Siui.Cloud.Medical.Web\src\layout\components\AppMain.vue
-->
<template>

    <navigation>
      <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
      </section>
    </navigation>

</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}
.fixed-header + .app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
